import { chatHistoryActions } from '@constants/actionTypes';

const defaultState = {
  answerLookup: {},
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case chatHistoryActions.updateResultAnswer: {
      const { resultId, answer, error } = action.payload;
      return {
        ...state,
        answerLookup: {
          ...state.answerLookup,
          [resultId]: { ...state.answerLookup[resultId], answer, error: error || null },
        },
      };
    }
    case chatHistoryActions.updateResultError: {
      const { resultId, error } = action.payload;

      return {
        ...state,
        answerLookup: {
          ...state.answerLookup,
          [resultId]: { ...state.answerLookup[resultId], error },
        },
      };
    }
    case chatHistoryActions.clearChatHistoryData: {
      return {
        ...state,
        answerLookup: {},
      };
    }
    default:
      return state;
  }
}
